export interface DataSource {
  id: number;
  name: string;
  desc: string;
  icon: string;
}

export const exampleDataSource: DataSource = {
  id: 1,
  name: 'Purchase',
  desc: 'People bought stuff',
  icon: 'fas fa-usd-circle',
};

export const exampleDataSourceWithSuggestions: DataSource = {
  ...exampleDataSource,
};
